import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { ILoadingIndicatorState } from './loading-indicator.reducer';
import * as fromReducer from './loading-indicator.reducer';

const getLoadingIndicatorState = createFeatureSelector<ILoadingIndicatorState>('loadingIndicator');

export const getLoadingIndicatorStatus = createSelector(
  getLoadingIndicatorState,
  fromReducer.getLoadingIndicatorStatus
);
